import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  &.carousel-my-apps,
  .carousel-my-apps {
    &__title-wrap {
      margin-bottom: 15px;
    }

    &--want-to-watch {
      .carousel-my-apps__title-wrap {
        position: relative;
        margin-bottom: -30px;
        margin-right: 80px;
        z-index: 1;
      }
    }

    &__title {
      margin-bottom: 15px;
    }
  }
`;

export const CarouselWrapper = styled.div`
  .app-card__logo {
    img {
      width: auto;
    }
  }

  .stage-carousel {
    .swiper-slide {
      max-width: 285px;
    }

    ${breakpoints.down('xs')} {
      .swiper-slide {
        width: 255px;
      }
    }

    ${breakpoints.up('lg')} {
      padding-top: 0;

      .swiper-button-prev,
      .swiper-button-next {
        transform: translateY(0) !important;
      }
    }
  }
`;

export default Container;
